































import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppListSelector from '@/components/AppListSelector.vue'
import {
  relationRoles,
  rolesValues,
  rolesKeys
} from '@/modules/AccountContactRelation/helpers/account-contact'
import { createAccountContact, editAccountContactRoles } from '@/modules/AccountContactRelation/gql/account-contact.gql'
import { AccountContact } from '@/modules/AccountContactRelation/interfaces/account-contact'
import SearchAccount from '@/mixins/search-queries/search-account'
import SearchContact from '@/mixins/search-queries/search-contact'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { IBaseItemInput } from '@/interfaces/form-input'

@Component({
  components: {
    AppDialog,
    AppTextSearch,
    AppListSelector
  }
})
export default class RelationFormDialog extends mixins(SearchAccount, SearchContact) {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Boolean }) readonly disable!: boolean
  @Prop({ type: String }) readonly actionType!: string
  @Prop({ type: Object as () => AccountContact }) readonly relation!: AccountContact
  @Prop({ type: Object as () => Account }) readonly account!: Account
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  showDialog = false

  relationInput: {
    account: IBaseItemInput
    contact: IBaseItemInput
    roleIndexes: number[]
  } = {
    account: {
      name: ''
    },
    contact: {
      name: ''
    },
    roleIndexes: []
  }

  relationRoles = relationRoles
  rolesKeys = rolesKeys
  rolesValues = rolesValues

  @Watch('show')
  onShowChanged (val: boolean) {
    this.showDialog = val
    switch (this.actionType) {
      case 'new':
        this.newRelationHandler()
        break
      case 'edit':
        this.editRelationHandler()
        break
      default:
        break
    }
  }

  @Emit('post')
  onPostHandler () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  newRelationHandler () {
    if (this.account) {
      this.relationInput = {
        ...this.relationInput,
        account: {
          id: +this.account.id,
          name: this.account.name
        }
      }
      this.candidatesAccount = [this.account]
    }

    if (this.contact) {
      this.relationInput = {
        ...this.relationInput,
        contact: {
          id: +this.contact.id,
          name: this.contact.name
        }
      }
      this.candidatesContact = [this.contact]
    }
  }

  editRelationHandler () {
    const relation = this.relation
    const { account, contact } = relation
    const roles = relation.roles || []

    this.candidatesAccount = [account]
    this.candidatesContact = [contact]

    const roleIndexes = roles.map((role: string) => {
      return this.$R.findIndex((r: string) => r === role)(this.rolesKeys)
    })
    let relationInput = {
      account: {
        id: +account.id,
        name: account.name
      },
      contact: {
        id: +contact.id,
        name: contact.name
      },
      roleIndexes
    }

    this.relationInput = relationInput
  }

  clearRelationInput () {
    this.relationInput = {
      account: {
        name: ''
      },
      contact: {
        name: ''
      },
      roleIndexes: []
    }
    this.onPostHandler()
  }

  async accountConfirm () {
    if (this.actionType === 'new') {
      await this.newRelationPost()
    } else {
      await this.editRelationPost()
    }
  }

  async newRelationPost () {
    const {
      account: { id: accountId },
      contact: { id: contactId },
      roleIndexes
    } = this.relationInput

    const newRelationValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newRelationValid) {
      return
    }

    this.onPostHandler()

    const roles = roleIndexes.map((index: number) => {
      return this.rolesKeys[index]
    })

    try {
      const result = await this.$apollo.mutate({
        mutation: createAccountContact,
        variables: {
          accountContactInput: {
            accountId: Number(accountId),
            contactId: Number(contactId),
            roles
          }
        }
      })
      const res = result.data.createAccountContact
      if (res) {
        showNotification({
          msg: 'Create the new account contact relationship successfully',
          type: SnackType.Success
        })
        this.clearRelationInput()
        this.onSuccess()
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async editRelationPost () {
    const { roleIndexes } = this.relationInput

    const newRelationValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newRelationValid) {
      return
    }

    const { id } = this.relation as AccountContact

    const roles = roleIndexes.map((index: number) => {
      return this.rolesKeys[index]
    })

    this.onPostHandler()

    try {
      const res = await this.$apollo.mutate({
        mutation: editAccountContactRoles,
        variables: {
          accountContactId: Number(id),
          roles
        }
      })
      showNotification({
        msg: 'Update the account contact relationship successfully',
        type: SnackType.Success
      })
      this.clearRelationInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}

